var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalseeker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M211,91c0-8.291-6.709-15-15-15h-60c-8.291,0-15,6.709-15,15v30c0,8.291,6.709,15,15,15s15-6.709,15-15v-15h45   C204.291,106,211,99.291,211,91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,136c8.291,0,15-6.709,15-15V91c0-8.291-6.709-15-15-15h-60c-8.291,0-15,6.709-15,15s6.709,15,15,15h45v15   C361,129.291,367.709,136,376,136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,406h-45v-15c0-8.291-6.709-15-15-15s-15,6.709-15,15v30c0,8.291,6.709,15,15,15h60c8.291,0,15-6.709,15-15   S204.291,406,196,406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,376c-8.291,0-15,6.709-15,15v15h-45c-8.291,0-15,6.709-15,15s6.709,15,15,15h60c8.291,0,15-6.709,15-15v-30   C391,382.709,384.291,376,376,376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,181c0-24.814-20.186-45-45-45s-46,20.186-46,45s21.186,45,46,45S121,205.814,121,181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,301c0-41.353-33.647-75-75-75S0,259.647,0,301c0,8.291,6.709,15,15,15h121C144.291,316,151,309.291,151,301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,181c0-24.814-21.186-45-46-45s-45,20.186-45,45s20.186,45,45,45S482,205.814,482,181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,226c-41.353,0-75,33.647-75,75c0,8.291,6.709,15,15,15h121c8.291,0,15-6.709,15-15C512,259.647,477.353,226,436,226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,196c0-33.091-26.909-60-60-60s-60,26.909-60,60s26.909,60,60,60S316,229.091,316,196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,376h150c8.291,0,15-6.709,15-15v-15c0-49.629-40.371-90-90-90s-90,40.371-90,90v15C166,369.291,172.709,376,181,376z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalseeker);
export default __webpack_public_path__ + "static/media/total seeker.027f439f019121a98485ed9195a28b0b.svg";
export { ForwardRef as ReactComponent };